
                import "css-modules://src_components_gallery"
                export default {"Main":"_36ce55","Eyebrow":"_d8ed09","Title":"_824560","Subline":"_d14186","Header":"_8e884e","Items":"_7c2531","Item":"_a729e8","Image":"_8a823b","Job":"_3679e3","Name":"_77cd4b","Phone":"_e6645f"}
            